import { useGraphQLQuery } from '@betterment/graphql';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EnvelopeAccountTaxationTypesDocument } from './graphql/query.envelopeAccountTaxationTypes.generated';
import { RecurringTransactionOverviewCard } from './RecurringTransactionOverview/RecurringTransactionOverviewCard';

import { ENVELOPE_ACCOUNT_MANAGED_TYPE } from '../../../Shared/constants';

export const RecurringTransactionsCard: React.FC = () => {
  const accountId = useRequiredParam('accountId');

  const { data, loading } = useGraphQLQuery(EnvelopeAccountTaxationTypesDocument, { variables: { id: accountId } });

  if (!data || loading) return null;
  if (data.envelopeAccount.__typename !== ENVELOPE_ACCOUNT_MANAGED_TYPE) return null;

  return <RecurringTransactionOverviewCard accountId={accountId} />;
};
